import * as bidTypes from "store/actions/bid";

const initialState = "";

const bidReducer = (state = initialState, action) => {
  switch (action.type) {
    case bidTypes.ADD_BID:
      return action.data;
    default:
      return state;
  }
};

export default bidReducer;
